import script from "./Resume.vue?vue&type=script&setup=true&lang=js"
export * from "./Resume.vue?vue&type=script&setup=true&lang=js"

import "./Resume.vue?vue&type=style&index=0&id=2b1fff7e&scoped=true&lang=css"

import exportComponent from "/home/buddymetal/actions-runner/_work/candidate/candidate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b1fff7e"]])

export default __exports__